<!-- <all-projects *ngIf="oneTenant"></all-projects> -->

<div class="main-content" *ngIf="isToSelect">
  <div class="container-fluid">
      <div class="card sq-card">
        <div class="card-header card-header-squirrel">
            <h4 class="card-title">{{this.translate.data['SELECTTENANT'] | translate}}</h4>
          </div>


          <!-- <div class="card-header card-header-squirrel">
              <button matTooltip="{{this.translate.data['ADDTENANT'] | translate}}" mat-raised-button class="btn btn-squirrel pull-right" (click)="addTenant()" *ngIf="tenant">
                  <mat-icon>person_add</mat-icon>
              </button>
              <div class="clearfix"></div>
          </div> -->
          <!-- <div class="card-body" [ngSwitch]="gridView">
              <squirrel-data *ngSwitchCase="squirreldbView"></squirrel-data>
              <tenant-data *ngSwitchCase="tenantdbView"></tenant-data>               
          </div> -->
          <div class="card-body">                
              <div class="user-tenants-table">
                <ng-container *ngIf="!isLoadingResults">
                    <mat-option *ngFor="let tenant of userTenants" [value]="tenant" >
                        <div (click)="onRowClicked(tenant)">
                            <span>{{tenant.displayName}}</span>
                        </div>
                    </mat-option>
                </ng-container>
      <!-- <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                      <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                      <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                          Squirrel's API rate limit has been reached. It will be reset in one minute.
                          
                      </div>
                  </div> -->

                  <!-- <ag-grid-angular class="ag-theme-balham" style="height: 100%; width: 100%; padding: 5px;"
                  [overlayLoadingTemplate]="overlayLoadingTemplate"
                  [gridOptions]="gridOptions"
                  (gridReady)="onGridReady($event)" 
                  (rowClicked)="onRowClicked($event)"
                  [frameworkComponents]="frameworkComponents"               
                  [animateRows]="true"
                  [rowData]="rowData">
                  </ag-grid-angular> -->

                </div>
            </div>            
        </div>
    </div>
</div>





